import { createFileRoute } from '@tanstack/react-router'
import { AuditorVendorReviewPage } from '@/components/auditor-center/AuditorVendorDetailsPage'
import { auditorVendorSearchSchema } from '@/components/auditor-center/AuditorVendorsPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors_/$vendorId_/reviews/$assessmentId'
)({
  validateSearch: auditorVendorSearchSchema,
  component: AuditorVendorReviewPage,
})
